(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ActivityTypeInfoCustom', ActivityTypeInfoCustom);

    ActivityTypeInfoCustom.$inject = ['$resource'];

    function ActivityTypeInfoCustom($resource) {


        var getActivityTypeInfoByType = function (type) {

            var resourceUrl = 'api/get-activity-type-info-by-type?type=' + type;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getActivityTypeInfoByCurrentCompany = function () {

            var resourceUrl = 'api/get-activity-type-info-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getAllActivityTypeInfos = function () {

            var resourceUrl = 'api/get-all-activity-type-infos';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getActivityTypeInfoByType: getActivityTypeInfoByType,
            getActivityTypeInfoByCurrentCompany: getActivityTypeInfoByCurrentCompany,
            getAllActivityTypeInfos: getAllActivityTypeInfos

        };
    }
})();
